import React from 'react';
import { Modal, Button, Table, Badge } from 'react-bootstrap';
import ViewPdfButton from './ViewPdfButton';

function RowField({ label, value }) {
  return (
    <tr>
      <th style={{ width: 180 }}>{label}</th>
      <td>{value ?? '—'}</td>
    </tr>
  );
}

export default function ClientMinorViewModal({ show, onHide, minor }) {
  if (!minor) return null;

  const parentName = minor.parent
    ? `${minor.parent.firstName || ''} ${minor.parent.lastName || ''}`.trim()
    : '—';

  const getDocument = () => ({
    title: `Fiche compte mineur - ${minor.firstName || ''} ${minor.lastName || ''}`.trim(),
    sections: [
      {
        title: 'Informations du compte mineur',
        rows: [
          { label: 'Prénom', value: minor.firstName || '—' },
          { label: 'Nom', value: minor.lastName || '—' },
          { label: 'Statut', value: minor.active ? 'Actif' : 'Désactivé' },
          { label: 'Date de naissance', value: minor.birthDate || '—' },
          { label: 'Relation', value: minor.relation || '—' },
          { label: 'Téléphone', value: minor.phone || '—' },
          { label: 'Email', value: minor.email || '—' },
          { label: 'Parent', value: parentName || '—' },
          { label: 'Parent ID', value: minor.parentId || '—' },
          { label: 'Notes', value: minor.notes || '—' },
        ],
      },
    ],
  });

  return (
    <Modal show={show} onHide={onHide} size="lg" backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>Voir — Compte mineur</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Table bordered size="sm">
          <tbody>
            <RowField label="Prénom" value={minor.firstName} />
            <RowField label="Nom" value={minor.lastName} />
            <RowField
              label="Statut"
              value={
                minor.active ? (
                  <Badge bg="success">Actif</Badge>
                ) : (
                  <Badge bg="danger">Désactivé</Badge>
                )
              }
            />
            <RowField
              label="Date de naissance"
              value={minor.birthDate || '—'}
            />
            <RowField label="Relation" value={minor.relation || '—'} />
            <RowField label="Téléphone" value={minor.phone || '—'} />
            <RowField label="Email" value={minor.email || '—'} />
            <RowField label="Parent" value={parentName} />
            <RowField label="Parent ID" value={minor.parentId || '—'} />
            <RowField label="Notes" value={minor.notes || '—'} />
          </tbody>
        </Table>
      </Modal.Body>
      <Modal.Footer>
        <ViewPdfButton getDocument={getDocument} className="me-2" />
        <Button variant="secondary" onClick={onHide}>
          Fermer
        </Button>
      </Modal.Footer>
    </Modal>
  );
}